import { useState, useEffect } from "react";
import { MyProfile } from "../../../components/dashboard/user-dashboard/profile/MyProfile";
import TopHeader from "../../../components/dashboard/user-dashboard/TopHeader";
import { getUserWiseProfile } from "../../../service/DashboardService";
import errorImage from '../../../assets/images/error.png'
import loader from "../../../assets/images/loader.gif"; 


const UserProfilePage = () => {
  const [userDetail, setUserDetail] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const token = localStorage.getItem("accessToken");
        const userId = localStorage.getItem("userId");
        const response = await getUserWiseProfile(userId, token);
        setUserDetail(response);
        setLoading(false)
      } catch (error) {
        setError(error)
        setLoading(false)
      }
    };
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);



  return (
    <div>
      <TopHeader tabName={"Account Settings"} />
      {loading ? (
        <div className="flex justify-center ">
          <img src={loader} alt="Loading" />
        </div>
      )  : error ? (
        <div className="flex justify-center items-center h-screen">
          <img src={errorImage} alt="error" />
        </div>
      ): (
        <div className="p-6 bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg">
          <MyProfile userDetail={userDetail}/>
        </div>



      //   <div className="md:flex">
      //   <ul className="flex-column space-y space-y-2 text-sm font-medium text-gray-800 dark:text-gray-400 md:me-4 mb-4 md:mb-0">
      //     {tabs.map((tab) => (
      //       <li key={tab.key}>
      //         <a
      //           href="#"
      //           className={`inline-flex items-center px-2 py-3 rounded-lg ${
      //             activeTab === tab.key
      //               ? "text-blue-500 bg-blue-100"
      //               : "hover:text-gray-900"
      //           }`}
      //           onClick={() => handleTabClick(tab.key)}
      //           aria-disabled={tab.disabled ? "true" : "false"}
      //         >
      //           {tab.label}
      //         </a>
      //       </li>
      //     ))}
      //   </ul>
      //   <div className="p-6 bg-gray-50 text-medium text-gray-500 dark:text-gray-400 dark:bg-gray-800 rounded-lg w-5/6">
      //     {tabs.map((tab) => (
      //       <div
      //         key={tab.key}
      //         style={{ display: activeTab === tab.key ? "block" : "none" }}
      //       >
      //         <div className="mb-2">{tab.content}</div>
      //       </div>
      //     ))}
      //   </div>
      // </div>
      )}
      
    </div>
  );
};

export default UserProfilePage;
